const STORAGE_KEY = '__MY_STORAGE__';

export default STORAGE_KEY;
